var _defs, _g, _g2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHtmlLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    zoomAndPan: "magnify",
    viewBox: "0 0 37.5 37.499999",
    height: 50,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "935e4dfcaa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 37.007812 0 L 37.007812 37.007812 L 0 37.007812 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e890dc5cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.890625 7.5 L 28.390625 7.5 L 28.390625 30 L 8.890625 30 Z M 8.890625 7.5 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#935e4dfcaa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 45 L 0 45 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#545454",
    d: "M 0 0 L 37.5 0 L 37.5 37.5 L 0 37.5 Z M 0 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e890dc5cd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e44d26",
    d: "M 10.660156 27.699219 L 8.886719 7.566406 L 28.394531 7.566406 L 26.621094 27.695312 L 18.628906 29.933594 Z M 10.660156 27.699219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f16529",
    d: "M 25.097656 26.414062 L 26.617188 9.214844 L 18.640625 9.214844 L 18.640625 28.222656 Z M 25.097656 26.414062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 18.632812 11.683594 L 12.515625 11.683594 L 13.175781 19.148438 L 18.640625 19.148438 L 18.640625 16.679688 L 15.410156 16.679688 L 15.183594 14.152344 L 18.640625 14.152344 L 18.640625 11.683594 Z M 18.640625 23.082031 L 18.628906 23.085938 L 15.910156 22.34375 L 15.738281 20.375 L 13.285156 20.375 L 13.625 24.25 L 18.628906 25.648438 L 18.640625 25.644531 Z M 18.640625 23.082031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 18.632812 19.148438 L 21.640625 19.148438 L 21.363281 22.351562 L 18.640625 23.09375 L 18.640625 25.660156 L 23.648438 24.257812 L 24.316406 16.679688 L 18.640625 16.679688 Z M 24.691406 12.34375 L 24.75 11.683594 L 18.632812 11.683594 L 18.632812 14.152344 L 24.53125 14.152344 L 24.578125 13.597656 Z M 24.691406 12.34375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlLogo);
export default __webpack_public_path__ + "static/media/HtmlLogo.623035e7a1baaefa8ce0fd2743c1515b.svg";
export { ForwardRef as ReactComponent };